import { ContractList } from "../staticInfo/state";
import { ContractImageType, ContractZone } from "./state";


export const handleChangeContractNameAction = (contractName: string) => ({
  type: '@@Contract/changeContractName' as const,
  contractName
});

export const handleChangeContractIsActiveAction = (is_active: string) => ({
  type: '@@Contract/handleChangeContractIsActiveAction' as const,
  is_active
});

export const handleChangeContractIsInspectionAction = (need_inspect: string) => ({
  type: '@@Contract/handleChangeContractNeedInspectAction' as const,
  need_inspect
});

export const handleChangeContractImageTypeIdAction = (image_type_id: string) => ({
  type: '@@Contract/handleChangeContractImageTypeIdAction' as const,
  image_type_id
});

export const handleChangeContractReportTitleAction = (report_title: string) => ({
  type: '@@Contract/handleChangeContractReportTitleAction' as const,
  report_title
});

export const handleSetContractZoneListAction = (zoneList: ContractZone[]) => ({
  type: '@@Contract/handleSetContractZoneListAction' as const,
  zoneList
});

export const handleChangeContractZoneFieldAction = (
  index: number,
  field: keyof ContractZone,
  value: string | number
) => ({
  type: '@@Contract/handleChangeContractZoneFieldAction' as const,
  index,
  field,
  value
});

export const handleAddContractZoneAction = () => ({
  type: '@@Contract/handleAddContractZoneAction' as const,
});

export const handleInitEditContractAction = (contract: ContractList) => {
  return {
    type: '@@Contract/handleInitEditContractAction' as const,
    contract
  }
}

export const clearContractDataAction = () => ({
  type: '@@Contract/clearContractDataAction' as const
})

export const handleSetImageTypeListAction = (imageTypeList: ContractImageType[]) => ({
  type: '@@Contract/handleSetImageTypeListAction' as const,
  imageTypeList
});

export const handleAddImageTypeAction = (imageType: ContractImageType) => ({
  type: '@@Contract/handleAddImageTypeAction' as const,
  imageType
});

export const handleUpdateImageTypeAction = (index: number, imageType: ContractImageType) => ({
  type: '@@Contract/handleUpdateImageTypeAction' as const,
  index,
  imageType
});

export const handleRemoveImageTypeAction = (index: number) => ({
  type: '@@Contract/handleRemoveImageTypeAction' as const,
  index
});

export const handleMoveImageTypeAction = (index: number, direction: 'up' | 'down') => ({
  type: '@@Contract/handleMoveImageTypeAction' as const,
  index,
  direction
});

export const handleOpenAddZoneDialogAction = () => ({
  type: '@@Contract/handleOpenAddZoneDialogAction' as const,
});

export const handleCloseAddZoneDialogAction = () => ({
  type: '@@Contract/handleCloseAddZoneDialogAction' as const,
});

export type ContractAction =
  ReturnType<typeof handleChangeContractNameAction>
  | ReturnType<typeof handleChangeContractIsActiveAction>
  | ReturnType<typeof handleChangeContractIsInspectionAction>
  | ReturnType<typeof handleChangeContractImageTypeIdAction>
  | ReturnType<typeof handleChangeContractReportTitleAction>
  | ReturnType<typeof handleSetContractZoneListAction>
  | ReturnType<typeof handleChangeContractZoneFieldAction>
  | ReturnType<typeof handleAddContractZoneAction>
  | ReturnType<typeof handleInitEditContractAction>
  | ReturnType<typeof clearContractDataAction>
  | ReturnType<typeof handleSetImageTypeListAction>
  | ReturnType<typeof handleAddImageTypeAction>
  | ReturnType<typeof handleUpdateImageTypeAction>
  | ReturnType<typeof handleRemoveImageTypeAction>
  | ReturnType<typeof handleMoveImageTypeAction>
  | ReturnType<typeof handleOpenAddZoneDialogAction>
  | ReturnType<typeof handleCloseAddZoneDialogAction>
